var render = function render(){var _vm=this,_c=_vm._self._c;return _c('list-select',{ref:"select",attrs:{"emit-only-value":"","search-data":_vm.search,"search-only-select":_vm.searchOnlySelect,"parse-callback":_vm.parse,"expand":_vm.expand,"disabled":_vm.disable},on:{"input":(v) => _vm.$emit('input', v)},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})
}
var staticRenderFns = []

export { render, staticRenderFns }